export const OPEN_CART_COOKIE_NAME = "da-open-cart";
export const OPEN_CART_COOKIE_VALUE = "1";

const OPEN_CART_COOKIE_MAX_AGE_SECONDS = 60;

export function serializeOpenCartFromNavigationCookie(): string {
	return `${OPEN_CART_COOKIE_NAME}=${OPEN_CART_COOKIE_VALUE}; Path=/; Max-Age=${OPEN_CART_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`;
}

export function isOpenCartCookiePending(): boolean {
	if (typeof document === "undefined") {
		return false;
	}
	return document.cookie.split(";").some((part) => {
		return part.trim() === `${OPEN_CART_COOKIE_NAME}=${OPEN_CART_COOKIE_VALUE}`;
	});
}

export function clearOpenCartFromNavigationCookie(): void {
	if (typeof document === "undefined") {
		return;
	}
	document.cookie = `${OPEN_CART_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
}
